<template>
    <div class="mx-auto text-center lg:max-w-3xl justify-center">
        <div class="h-auto mx-2 py-2 bg-white md:border md:border-black" v-show="singleCoupon || multiCoupon || specialDatesCoupon">
            <p v-if="singleCoupon" v-html="$t(getSingleGiftCopy(singleCoupon), {couponCode: singleCoupon.code, discount: couponDiscount(singleCoupon), remainingBoxes, boxLabel})"></p>
            <p v-if="multiCoupon" v-html="$t('CHOOSE_YOUR_GIFT_MULTI_COUPON', {couponCode: multiCoupon.code, discount: couponDiscount(multiCoupon), minBoxes: multiCoupon.minimumWeeks})"></p>
            <p v-if="specialDatesCoupon" v-html="$t('CHOOSE_YOUR_GIFT_SPECIAL_DATES_COUPON', {couponCode: specialDatesCoupon.code, discount: couponDiscount(specialDatesCoupon)})"></p>
        </div>
        <div class="flex flex-wrap justify-center">
            <div class="flex w-full h-auto container-tablet">
                <div class="container-oneOff">
                    <img src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/miscellaneous/Gifting-Christmas-One-Off.jpg"
                         alt="One-off box"
                         class="image-size">
                    <h3>{{ $t('CHOOSE_YOUR_GIFT_ONE_OFF', {price: hasPopEnabled}) }}</h3>
                    <p v-if="isFreeVase" v-text="$t('CHOOSE_YOUR_GIFT_SEND_ONE_FREE_VASE')"></p>
                    <p v-else class="text-margin" v-text="$t('CHOOSE_YOUR_GIFT_SEND_ONE')"/>
                    <button class="btn btn--primary mt-2 button-color"
                            @click="$emit('select-one-box')"
                            v-text="$t('CHOOSE_YOUR_GIFT_PERFECT')"/>
                    <div>
                    <ul class="list-disc font-light text-left text-content">
                        <li v-text="$t(popBoxOneoff)"></li>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_WE_INCLUDE')"></li>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_YOUR_CARD')"></li>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_YOUR_DELIVERY')"></li>
                    </ul>
                    </div>
                </div>
            </div>
            <div class="w-fulldivider--container md:hidden">
                <div class="box-divider"/>
            </div>
            <div class="flex w-full container-tablet">
                <div class="container-box">
                    <img src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/miscellaneous/Gifting-Christmas-Subscription.jpg"
                         alt="Regular delivery"
                         class="image-size">
                    <h3>{{ $t('CHOOSE_YOUR_GIFT_DELIVERY_FOR', {price: hasPopMultiEnabled}) }}</h3>
                    <p class="text-margin" v-text="$t('CHOOSE_YOUR_GIFT_SEND_A_SET')"/>

                    <button
                        class="btn btn--primary mt-2 button-color"
                        @click="$emit('select-subscription')"
                        v-text="$t('CHOOSE_YOUR_GIFT_SEND_THEM')"/>

                    <ul class="list-disc font-light text-left text-multi-gifting">
                        <li v-html="$t(popBoxMulti)"/>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_FREE_CARD')"/>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_SET_THEM_UP')"/>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'GiftTypeBoxes',
    mounted() {
        this.$store.dispatch('gifting/fetchGiftingCoupons');
    },
    computed: {
        ...mapGetters({
            multiCoupon: 'gifting/getMultiGiftCoupon',
            singleCoupon: 'gifting/getSingleGiftCoupon',
            subscription: 'subscription/getActiveSubscription',
            specialDatesCoupon: 'gifting/getSpecialDatesGiftCoupon',
            isFreeVase: 'account/isFreeVase',
            isPopEnabled: 'account/getPopSingleGift',
            isPopMultiEnabled: 'account/getPopMultiGift',
        }),
        pricePerSubscriptionDelivery() {
            let price = this.$store.getters['gifting/getPricePerSubscriptionDelivery'];

            return parseInt(price || 0);
        },
        pricePerOneOffDelivery() {
            let price = this.$store.getters['gifting/getPricePerOneOffDelivery'];

            return parseInt(price || 0);
        },
        paidVasePrice() {
            let price = this.$store.getters['gifting/getPaidVasePrice'];

            return parseInt(price || 0);
        },
        remainingBoxes() {
            return this.subscription?.single_gift_coupon_remaining_deliveries;
        },
        boxLabel() {
            return (this.remainingBoxes === 1) ? 'box' : 'boxes';
        },
        hasSpecialDatesCoupon() {
            return !this.specialDatesCoupon?.special_dates_gifting_coupon_redeemed && this.specialDatesCoupon?.amount !== null;
        },
        popBoxOneoff() {
            return this.isPopEnabled ? 'CHOOSE_YOUR_GIFT_CHOOSE_DAY_POP' : 'CHOOSE_YOUR_GIFT_CHOOSE_DAY';
        },
        popBoxMulti() {
            return this.isPopMultiEnabled ? 'CHOOSE_YOUR_GIFT_CHOOSE_HOW_POP' : 'CHOOSE_YOUR_GIFT_CHOOSE_HOW';
        },
        pricePerOneOffPop() {
            let price = this.$store.getters['gifting/getPricePerOneOffPop'];

            return parseInt(price || 0);
        },
        pricePerSubscriptionPop() {
            let price = this.$store.getters['gifting/getPricePerSubscriptionPop'];

            return parseInt(price || 0);
        },
        hasPopEnabled() {
            return this.isPopEnabled ? this.pricePerOneOffPop : this.pricePerOneOffDelivery;
        },
        hasPopMultiEnabled() {
            return this.isPopMultiEnabled ? this.pricePerSubscriptionPop : this.pricePerSubscriptionDelivery;
        },
    },
    methods: {
        couponDiscount(coupon) {
            if (coupon.discountType === 'percentage') {
                return `${coupon.discount}%`;
            } else if (coupon.discountType === 'amount') {
                const saving = coupon.discount * 0.01;
                return `£${saving}`;
            }
        },
        getSingleGiftCopy(coupon) {
            const discount = coupon.discount;
            const remainingBoxes = this.remainingBoxes;
            if (discount === 100) {
                return remainingBoxes > 1 ? 'CHOOSE_YOUR_GIFT_ONE_OFF_MULTI_DELIVERIES_COUPON_FREE' : 'CHOOSE_YOUR_GIFT_ONE_OFF_COUPON_FREE';
            } else {
                return remainingBoxes > 1 ? 'CHOOSE_YOUR_GIFT_ONE_OFF_MULTI_DELIVERIES_COUPON' : 'CHOOSE_YOUR_GIFT_ONE_OFF_COUPON';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.image-size {
    height: 240px;
    width: 100%;
    left: 0px;
    top: 0px;
    border-radius: 0px;
}

.button-color {
    background-color: #262323;
    margin-top: 16px;
}
.box-divider {
    width: 350px;
    border: 0.5px solid #CECECE;
}

.container-oneOff {
    height: 650px;
    width: 100%;
    left: 241px;
    top: 178px;
    margin-top: 32px;
}

.container-box {
    height: 650px;
    width: 100%;
    left: 241px;
    top: 178px;
    margin-top: 32px;
}

.text-margin {
    height: 72px;
    font-size: 20px;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
}

.text-content {
    height: 116px;
    width: 300px;
    font-size: 18px;
    padding-left: 16px;
    top: 456px;
    padding-top: 16px;
    margin-left: 27px;
}
.text-multi-gifting{
    height: 224px;
    width: 300px;
    font-size: 18px;
    padding-left: 16px;
    padding-top: 16px;
    margin-left: 27px;
}
@media (min-width: 724px ) {
    .text-multi-gifting {
        height: 204px;
        width: 411px;
        font-size: 18px;
        padding-left: 16px;
        top: 456px;
        padding-top: 16px;
        margin-left: 27px;
    }

    .text-margin {
        height: 58px;
        font-size: 20px;
        width: 421px;
        padding-left: 24px;
        padding-right: 32px;
    }

    .container-box {
        height: 720px;
        width: 467px;
        top: 178px;
        padding-left: 16px;
        padding-right: 16px;
        border-radius: 8px;
        border: solid 1px #CECECE;
    }

    .container-oneOff {
        height: 720px;
        width: 467px;
        top: 178px;
        padding-left: 16px;
        padding-right: 16px;
        border-radius: 8px;
        border: solid 1px #CECECE;
    }

    .box-divider {
        display: none;
    }

    .image-size {
        height: 274px;
        width: 435px;
        left: 257px;
        padding-top: 16px;
        top: 194px;
        border-radius: 0px;
    }

    .text-content {
        height: 96px;
        width: 411px;
        font-size: 18px;
        padding-left: 16px;
        padding-top: 16px;
        margin-left: 27px;
    }
}
.container-tablet {
    max-width: 24rem;
}
</style>
